import React from 'react';
const SubmitButton = ({ state, text }) => {
    return (React.createElement("button", { "data-testid": "submit", disabled: state.isFormInvalid, type: "submit" }, text));
};
export default SubmitButton;
